import React from "react";
import TestimonialCard from "./TestimonialCard";
import useScrollAnimation from "../../../hooks/useScrollAnimation";

/**
 * Staggered masonry-style grid for testimonials
 * @param {Object} props
 * @param {Array} props.testimonials - Array of testimonial objects
 * @param {string} props.title - Section title
 */
const TestimonialGrid = ({
  testimonials,
  title = "What my friends say (no filter)",
}) => {
  const [titleRef, titleVisible] = useScrollAnimation({ threshold: 0.3 });

  return (
    <section className="pt-12 pb-20 px-4 bg-cloud-100">
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <div
          ref={titleRef}
          className={`text-center mb-16 transition-all duration-700 ${
            titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="display-section">
            <span className="text-gradient">What my friends say</span>
          </h2>
          <p className="mt-4 text-earth-500 text-lg">(no filter)</p>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={testimonial.name}
              name={testimonial.name}
              location={testimonial.location}
              testimony={testimonial.testimony}
              image={testimonial.image}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialGrid;
